import { downgradeComponent } from "@angular/upgrade/static";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { HealthCheckComponent } from "src/app/main/components/diagnostics/healthCheck/healthCheck.component";
import { PageStateNames } from "../../../class/PageStateNames";
import { DiagnosticsController } from "./diagnostics.controller";
import { DiagnosticsService } from "./diagnostics.service";
import { FormBuilderComponent } from "./formBuilder/formBuilder.component";
import { FormBuilderService } from "./formBuilder/formBuilder.service";
import { UpdateFormDetailsComponent } from "./formBuilder/updateFormDetails/updateFormDetails.component";
import { UserAccessTesterComponent } from "./permissions/user-access-tester/user-access-tester.component";
import { VideoDiagnosticsComponent } from "./videoDiagnostics/videoDiagnostics.component";
import { VideoDiagnosticsService } from "./videoDiagnostics/videoDiagnostics.service";

export class Config {

    static $inject = ["$stateProvider"];

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(PageStateNames.COMPONENTS_DIAGNOSTICS, {
            url: "/components/diagnostics/:page/:option",
            views: {
                "content@app": {
                    template: require("./diagnostics.html"),
                    controller: "diagnosticsController as $ctrl"
                }
            },
            params: {
                title: "Diagnostics",
                page: { squash: true, value: null, dynamic: true },
                option: { squash: true, value: null, dynamic: true }
            }
        });
    }
}

angular
    .module("app.components.diagnostics", [
        "ui.router",
        "app.components.util.api",
        "ngMaterial",
        "ngMessages"
    ])
    .config(Config)

    .service("diagnosticsService", DiagnosticsService)
    .service("formBuilderService", FormBuilderService)

    .component("formBuilder", new FormBuilderComponent())
    .component("updateFormDetails", new UpdateFormDetailsComponent())
    .component("healthCheck", new HealthCheckComponent())

    .component("videoDiagnostics", new VideoDiagnosticsComponent())
    .service("videoDiagnosticsService", VideoDiagnosticsService)

    .directive("userAccessTester", downgradeComponent({ component: UserAccessTesterComponent }))

    .controller("diagnosticsController", DiagnosticsController);
